import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectAbandonStatus = createSelector(
  [(store: RootState) => store.documentUpdate.abandonStatus],
  (data) => data
);
